import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Message } from 'primeng/api';
import { PartnershipService } from '../../partnership.service';
import { PrivilegeService } from '../../privilege.service';
import { UserGroupService } from '../../user-group.service';
import { PartnerRelationship, Relationship, Privilege, PrivilegeGroup, UserGroup } from '../../models';

@Component({
  selector: 'app-edit-user-group',
  templateUrl: './edit-user-group.component.html',
  styleUrls: ['./edit-user-group.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [PrivilegeService, UserGroupService]
})

export class EditUserGroupComponent implements OnInit {

  @Output() cancelEditEvent = new EventEmitter<boolean>();
  @Output() setBreadCrumbs = new EventEmitter<any[]>();
  @Output() setMessage = new EventEmitter<{}>();
  @Input() existingGroupNames: any[];
  @Input() currentUserGroup: UserGroup;

  partnerRelationship: PartnerRelationship[];
  relationship: Relationship[];
  privilegesWithRelationship: Privilege[] = [];
  privilegesWithRelationshipType: Privilege[] = [];
  preLoadedPrivileges: Privilege[] = [];
  privilegesSelected: Privilege[];
  privilegesSelectedToolTip: any[];
  userGroupData: UserGroup = {};
  userGroupNameVerification = false;
  userGroupExists = false;
  loading = false;
  processing = false;
  postActionErrorMessage: Message[] = [];

  /* ----- Form Groups and Controls ----*/
  public editUserGroupForm: FormGroup = new FormGroup({
    userGroupName: new FormControl('', [Validators.required]),
    PrivilegeIds: new FormControl('', [Validators.required])
  });
  userGroupNameControl = this.editUserGroupForm.get('userGroupName');
  privilegeDataControl = this.editUserGroupForm.get('PrivilegeIds');

  constructor(private partnershipService: PartnershipService
    , private privilegeService: PrivilegeService
    , private userGroupService: UserGroupService) { }

  ngOnInit() {
    this.loading = true;
    /* -- Set Default Loaded Values -- */
    this.userGroupNameControl.setValue(this.currentUserGroup.PrivilegeGroup.GroupName);
    this.populateAndSelectPrivileges(this.currentUserGroup.RelationshipId);
  }

  cancelEditUserGroup(): void {
    this.setBreadCrumbs.emit([{ label: 'User Group' }]);
    this.cancelEditEvent.emit(false);
    this.setMessage.emit('');
  }

  populateAndSelectPrivileges(RelationshipId: number): void {
    /* --- Get relationship data for this partner --- */
    if (RelationshipId) {
      this.partnershipService.findById(RelationshipId)
        .subscribe((partnership) => {
          this.partnerRelationship = (partnership as any).data;
          this.relationship = [];
          this.relationship.push({
            Id: this.partnerRelationship[0].RelationshipId,
            Company: {
              Name: this.partnerRelationship[0].ChildCompany.Name + ' - ' + this.partnerRelationship[0].ParentCompany.Name
            }
          });
          this.filterAndSelectPrivileges(this.relationship);
        });
    }
  }

  filterAndSelectPrivileges(relationship: Relationship[]): void {
    /* --- Get all privileges for this partner type --- */
    this.privilegeService.findByRelationship(relationship)
      .subscribe((privileges) => {
        this.privilegesWithRelationshipType = (privileges as any).data[0].Privileges;
        /*--- In the Privileges dropdown, select all the privileges with the selected partner */
        this.preLoadedPrivileges = this.privilegesWithRelationshipType.filter((item) => {
          let isSelected = false;
          for (let i = 0; i < this.currentUserGroup.PrivilegeGroup.Privileges.length; i++) {
            if (item.PrivilegeId === this.currentUserGroup.PrivilegeGroup.Privileges[i].PrivilegeId) {
              isSelected = true;
              break;
            }
          }
          return isSelected;
        });
      });
  }

  selectPrivileges(privilege: any): void {
    this.privilegesSelected = privilege.Privileges;
    this.privilegesSelectedToolTip = privilege.PrivilegesToolTip;
  }

  onUserGroupNameChange() {
    this.userGroupExists = false;
    this.existingGroupNames.splice(this.existingGroupNames.indexOf(this.currentUserGroup.PrivilegeGroup.GroupName), 1);
    if (this.existingGroupNames.indexOf( (this.userGroupNameControl.value).trim().toLowerCase() ) !== -1) {
      this.userGroupExists = true;
    }
  }

  displaySelectedItems(displayDiv, event): void {
    if (typeof this.privilegesSelectedToolTip !== 'undefined' && this.privilegesSelectedToolTip.length > 0) {
      displayDiv.show(event);
    }
  }

  createPrivilegeGroupData(): any {
    const privilegeGroupData = {};
    privilegeGroupData['RelationshipId'] = this.currentUserGroup.RelationshipId;
    privilegeGroupData['GroupName'] = this.userGroupNameControl.value;
    privilegeGroupData['Privileges'] = this.privilegesSelected;
    privilegeGroupData['CompanyGroupId'] = this.currentUserGroup.PrivilegeGroup.CompanyGroupId;
    return privilegeGroupData;
  }

  onSubmit() {
    this.processing = true;
    const privilegeGroupData = this.createPrivilegeGroupData();
    const message = {};
    this.userGroupData.PrivilegeGroup = privilegeGroupData;
    this.userGroupData.RelationshipId = privilegeGroupData.RelationshipId;
    this.userGroupService.update(this.userGroupData)
      .subscribe((userGroup: any) => {
        this.cancelEditEvent.emit(false);
        this.setBreadCrumbs.emit([{ label: 'User Groups' }]);
        this.processing = false;
        message['severity'] = 'success';
        message['summary'] = 'Changes saved successfully.';
        this.setMessage.emit(message);
      },
        error => {
          this.processing = false;
          this.postActionErrorMessage = [{severity: 'error', summary: 'An error occurred while saving changes.'}];
        });
  }
}
